import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const LogoutController = () => {
    const navigate = useNavigate();
    useEffect(() => {
         localStorage.clear();
         return navigate("/login");
    }, );
  
};

export default LogoutController;
